export type TemplateKey = 'invoice' | 'check' | 'document' | 'renegotiation';

export type TemplateRow = Record<string, string>;

export const INVOICE_TEMPLATE_ROWS: TemplateRow[] = [
  {
    Folio: '123',
    'Razon Social': 'Tech Spa',
    RUT: '11111111-1',
    'Fecha Recepcion': '14/08/2025',
    Vencimiento: '14/09/2025',
    'Monto total': '100000',
    Codigo: '33',
  },
];

export const CHECK_TEMPLATE_ROWS: TemplateRow[] = [
  {
    Folio: '001',
    RUT: '22222222-2',
    Fecha: '01/09/2025',
    Monto: '50000',
    'Razon social': 'Tech Spa',
    Vencimiento: '15/09/2025',
  },
];

export const DOCUMENT_TEMPLATE_ROWS: TemplateRow[] = [
  {
    Folio: '456',
    RUT: '33333333-3',
    Fecha: '15/09/2025',
    Monto: '75000',
  },
];

export const RENEGOTIATION_TEMPLATE_ROWS: TemplateRow[] = [
  {
    Folio: '789',
    Fecha: '20/09/2025',
    Monto: '120000',
    RUT: '44444444-4',
    Vencimiento: '25/09/2025',
  },
];

const TEMPLATES_BY_KEY: Record<TemplateKey, TemplateRow[]> = {
  invoice: INVOICE_TEMPLATE_ROWS,
  check: CHECK_TEMPLATE_ROWS,
  document: DOCUMENT_TEMPLATE_ROWS,
  renegotiation: RENEGOTIATION_TEMPLATE_ROWS,
};

const TEMPLATE_FILENAMES: Record<TemplateKey, string> = {
  invoice: 'template_facturas.xlsx',
  check: 'template_cheques.xlsx',
  document: 'template_documentos.xlsx',
  renegotiation: 'template_renegociaciones.xlsx',
};

export function getTemplateRows(key: TemplateKey): TemplateRow[] {
  return TEMPLATES_BY_KEY[key] ?? DOCUMENT_TEMPLATE_ROWS;
}

export function getTemplateFilename(key: TemplateKey): string {
  return TEMPLATE_FILENAMES[key] ?? TEMPLATE_FILENAMES.document;
}
